import { useCallback, useEffect, useRef } from 'react';
import { Location, useBlocker, useLocation } from 'react-router';

export function usePrompt(when: boolean) {
  const location = useLocation();
  const activePathRef = useRef(location.pathname);

  // Update the active path when component mounts or when the location changes
  useEffect(() => {
    activePathRef.current = location.pathname;
  }, [location]);

  const blocker = useBlocker(
    useCallback(
      ({
        currentLocation,
        nextLocation,
      }: {
        currentLocation: Location;
        nextLocation: Location;
      }) => {
        // Only block if:
        // 1. The component wants to block (when === true)
        // 2. The component is on the current active path
        // 3. The user is trying to navigate away from this path
        return (
          when &&
          currentLocation.pathname === activePathRef.current &&
          currentLocation.pathname !== nextLocation.pathname
        );
      },
      [when],
    ),
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const proceed = window.confirm(
        'У вас є незбережені зміни. Ви впевнені, що хочете залишити сторінку?',
      );
      if (proceed) blocker.proceed();
      else blocker.reset();
    }
  }, [blocker]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (when) {
        e.preventDefault();
        e.returnValue =
          'У вас є незбережені зміни. Ви впевнені, що хочете залишити сторінку?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when]);
}
